import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import combineStyles from '../../utils/combineStyles';
import { withStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import TypographyStyles from '../../styles/typography';
import LayoutStyles from '../../styles/layout';
import SpacingStyles from '../../styles/helpers/spacing';
import LabelsStyles from './__styles__/Labels.styles';
import FormItemContainerStyles from '../../components/Global/Containers/__styles__/FormItemContainer.styles';

class Shipper extends Component {
  render() {
    const { pickup, classes, t } = this.props;

    return (
      <Grid item xs={3} className={classes.labelFont}>
        <div className={classes.underline}>{t('SHIP FROM')}:</div>
        <div>{pickup.locationName}</div>
        <div>{pickup.locationAddress.address1}</div>
        <div>{pickup.locationAddress.address2}</div>
        <div>
          {pickup.locationAddress.city}, {pickup.locationAddress.state}{' '}
          {pickup.locationAddress.postalCode}
        </div>
        {pickup.locationAddress.country !== 'US' && (
          <div className={classes.uppercase}>
            {pickup.locationAddress.country}
          </div>
        )}
      </Grid>
    );
  }
}

const translatedShipper = withNamespaces()(Shipper);
export default withStyles(
  combineStyles(
    LabelsStyles,
    FormItemContainerStyles,
    TypographyStyles,
    LayoutStyles,
    SpacingStyles
  )
)(translatedShipper);
